import React, { Fragment, FunctionComponent, useMemo } from 'react'
import cn from 'classnames'
import Link from 'next/link'

import { NavigationLink } from '@/store/NavigationMenu/NavigationTypes'
import { NavigationBack } from '@/modules/MainLayout/components/NavigationBack'
import { Button } from '@/components/Button'
import { useMarketingUrl } from '@/hooks/MarketingUrl'

import styles from './NavigationThirdLevel.module.scss'

type NavigationThirdLevelProps = {
  isVisible: boolean
  title: string
  className?: string
  subMenu: NavigationLink[]
  onBack?: () => void
  onLinkClick?: () => void
  onShowAll?: () => void
}

export const NavigationMenuThirdLevel: FunctionComponent<
  NavigationThirdLevelProps
> = ({
  isVisible,
  title,
  className,
  subMenu,
  onBack,
  onLinkClick,
  onShowAll,
}) => {
  const items = useMemo(() => {
    return subMenu
      .filter(
        (item): item is Omit<NavigationLink, 'href'> & { href: string } =>
          item.href != null
      )
      .slice(0, 10)
  }, [subMenu])

  return (
    <div
      className={cn(styles.container, className, {
        [styles.isVisible]: isVisible,
      })}
    >
      <NavigationBack title={title} onClick={onBack} className={styles.back} />

      <div className={styles.menu}>
        {items.map((item) => (
          <Fragment key={item.title}>
            <ThirdLevelLink href={item.href} onLinkClick={onLinkClick}>
              {item.title}
            </ThirdLevelLink>
          </Fragment>
        ))}
      </div>

      <Button variant="opacity" className={styles.showAll} onClick={onShowAll}>
        Cмотреть все
      </Button>
    </div>
  )
}

type ThirdLevelLinkProps = {
  href: string
  onLinkClick?: () => void
  children: React.ReactNode
}

const ThirdLevelLink: FunctionComponent<ThirdLevelLinkProps> = ({
  href,
  onLinkClick,
  children,
}) => {
  const marketingUrl = useMarketingUrl()
  const marketingHref = marketingUrl(href)

  return (
    <Link className={styles.link} href={marketingHref} onClick={onLinkClick}>
      {children}
    </Link>
  )
}
